import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 340px;
  height: 295px;
`;
